import { render, staticRenderFns } from "./OrgSaasLoginPagePreview.vue?vue&type=template&id=2df21e8e&lang=true"
import script from "./OrgSaasLoginPagePreview.vue?vue&type=script&lang=js"
export * from "./OrgSaasLoginPagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports